import { useState } from 'react'
import { Modal } from '../modal'
import { useStudentReviewModal } from './hooks/use-student-review-modal'

export type ActionType = 'grant' | 'deny'

interface StudentReviewModalProps {
  isOpen: boolean
  setOpen: (value: boolean) => void
  title?: string
  actionType: ActionType
  requestId?: string
}

export const StudentReviewModal = ({
  isOpen,
  setOpen,
  actionType,
  requestId
}: StudentReviewModalProps) => {
  const [isValid, setIsValid] = useState(true)
  const {
    states: { isPendingApprove, isPendingDisapprove },
    actions: { mutateApproveRequest, mutateDisapproveRequest }
  } = useStudentReviewModal(setOpen)

  const placeholders = {
    grant: 'Escreva "APROVAR" para confirmar',
    deny: 'Escreva "REPROVAR" para confirmar'
  }

  const textButton = {
    grant: 'Aprovar',
    deny: 'Reprovar'
  }

  const defaultText = {
    grant: {
      title: 'Aprovar Análise',
      description: (
        <div className="flex gap-5 flex-col">
          <strong className="text-[var(--brand-green)]">Aprovar</strong>
          <p>
            Seguindo com a <strong>aprovação</strong> sua análise será efetivada
            e todas os aproveitamentos/dispensas das disciplinas serão
            efetuadas!
          </p>
          <p>
            Se houver alguma mudança de currículo ela também será realizada.
          </p>
          <p>
            Por isso, pense bem antes de confirmar esta análise, pois ela será
            efetivada a partir da sua confirmação!
          </p>
          <p className="font-bold">
            Para seguir com esta{' '}
            <strong className="text-[var(--brand-green)]">aprovação</strong>
            {''} escreva a palavra{' '}
            <em className="text-[var(--brand-blue-1)]">“APROVAR”</em> no campo
            abaixo como confirmação da ação:
          </p>
        </div>
      )
    },
    deny: {
      title: 'Reprovar Análise',
      description: (
        <div className="flex gap-5 flex-col">
          <strong className="text-destructive">Reprovar</strong>
          <p>
            Seguindo com a <strong>reprovação</strong> sua análise será
            desconsiderada. O aproveitamento/dispensa das disciplinas não será
            realizado e não haverá qualquer mudança.
          </p>
          <p className="font-bold">
            Para seguir com esta{' '}
            <strong className="text-destructive">reprovação</strong> escreva a
            palavra <em className="text-[var(--brand-blue-1)]">“REPROVAR”</em>{' '}
            no campo abaixo como confirmação da ação:
          </p>
        </div>
      )
    }
  }

  function handleValidText(value: string) {
    setIsValid(value !== textButton[actionType].toUpperCase())
  }

  function approveRequest() {
    return mutateApproveRequest(requestId)
  }

  function disapproveRequest() {
    return mutateDisapproveRequest(requestId)
  }

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      title={actionType ? defaultText[actionType].title : ''}
      submitButtonDisabled={isValid}
      backButtonLabel="Cancelar"
      submitButtonLabel={textButton[actionType]}
      isLoading={isPendingDisapprove || isPendingApprove}
      submitAction={actionType === 'grant' ? approveRequest : disapproveRequest}
      submitButtonclassName={
        actionType === 'grant' ? 'bg-[var(--brand-green)]' : 'bg-destructive'
      }
    >
      {actionType && <p>{defaultText[actionType].description}</p>}
      <div className="pt-5">
        <input
          type="text"
          onChange={(e) => handleValidText(e.target.value)}
          className="w-full p-2.5 border border-[var(--brand-gray-1)] rounded-md text-center"
          placeholder={placeholders[actionType]}
        />
      </div>
    </Modal>
  )
}
